/**
 * @generated SignedSource<<5fa8cc7b6a14408d64e41eb22e7a7720>>
 * @relayHash cede02f3ba90a5f84e4be0077ead6dfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e1ed8c49247d1a72a774293db1058ae7a1d107d6c5a61ec7bf1fe7e63e1231f7

import type { ConcreteRequest } from 'relay-runtime';
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type GrowthUnifiedProfileTrialTrigger = "AUTO_UPGRADE_STORAGE_LIMIT" | "AUTO_UPGRADE_USER_LIMIT" | "CROSSFLOW_REVERSE_TRIAL" | "CROSSFLOW_USER_LIMIT" | "EDITION_PARITY" | "EDITION_PARITY_AUTO_PROVISIONING" | "REACTIVATION" | "REVERSE_TRIAL" | "UI" | "%future added value";
export type GrowthUnifiedProfileTrialType = "AUTO_UPGRADE" | "DIRECT_TRIAL" | "MANUAL_TRIAL" | "REVERSE_TRIAL" | "%future added value";
export type JiraApplicationKey = "JIRA_CORE" | "JIRA_CUSTOMER_SERVICE" | "JIRA_PRODUCT_DISCOVERY" | "JIRA_SERVICE_DESK" | "JIRA_SOFTWARE" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null> | null;
  hasRelationshipFromWithType?: string | null;
  inPreDunning?: boolean | null;
  inTrialOrPreDunning?: boolean | null;
};
export type editionAwarenessQuery$variables = {
  applicationKey: JiraApplicationKey;
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null;
  isServiceCollectionFree?: boolean | null;
  productKey: string;
  shouldCheckForAddPaymentDetails: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForDirectBuyChangeOffering: boolean;
  shouldCheckForPaymentDetails: boolean;
  shouldCheckForStorageLimit: boolean;
  shouldCheckForStorageUsageJira: boolean;
  shouldCheckForTrial: boolean;
};
export type editionAwarenessQuery$data = {
  readonly csm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jira?: {
    readonly attachmentStorageAllowed?: AGG$Long | null;
    readonly attachmentStorageIsUnlimited?: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly jsm_storage?: {
    readonly attachmentStorageAllowed: AGG$Long | null;
    readonly attachmentStorageIsUnlimited: boolean | null;
    readonly attachmentStorageUsed: AGG$Long | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly entitlementProfile: {
          readonly lastKnownTrial: {
            readonly createdAt: number | null;
            readonly offeringId: string | null;
            readonly trialEndTimeStamp: number | null;
            readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
            readonly trialType: GrowthUnifiedProfileTrialType | null;
          } | null;
        } | null;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
          readonly changeOfferingV2WithSkipTrial?: {
            readonly experienceUrl: string | null;
            readonly isAvailableToUser: boolean | null;
          } | null;
        } | null;
        readonly latestUsageForChargeElement?: number | null;
        readonly offering?: {
          readonly key: string | null;
          readonly trial: {
            readonly lengthDays: number | null;
          } | null;
        } | null;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null;
        } | null;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly entitlementId: string | null;
          readonly relationshipType: string | null;
        } | null> | null;
        readonly relatesFromEntitlementsWithCollectionType: ReadonlyArray<{
          readonly entitlement: {
            readonly entitlementProfile: {
              readonly lastKnownTrial: {
                readonly createdAt: number | null;
                readonly offeringId: string | null;
                readonly trialEndTimeStamp: number | null;
                readonly trialTrigger: GrowthUnifiedProfileTrialTrigger | null;
                readonly trialType: GrowthUnifiedProfileTrialType | null;
              } | null;
            } | null;
            readonly preDunning: {
              readonly status: CcpEntitlementPreDunningStatus | null;
            } | null;
          } | null;
        } | null> | null;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null;
                  readonly isAvailableToUser: boolean | null;
                } | null;
              } | null;
              readonly invoiceable: boolean | null;
            } | null;
          } | null;
          readonly trial: {
            readonly endTimestamp: number | null;
            readonly startTimestamp: number | null;
            readonly timeLeft: number | null;
          } | null;
        } | null;
        readonly transactionAccount: {
          readonly experienceCapabilities?: {
            readonly addPaymentMethodV2: {
              readonly experienceUrl: string | null;
              readonly isAvailableToUser: boolean | null;
            } | null;
          } | null;
          readonly isBillToPresent?: boolean | null;
          readonly isCurrentUserBillingAdmin: boolean | null;
          readonly key: string | null;
        } | null;
      } | null;
      readonly entitlementId: string;
    } | null;
  } | null> | null;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "applicationKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isServiceCollectionFree"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForAddPaymentDetails"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForDirectBuyChangeOffering"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaymentDetails"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageLimit"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForStorageUsageJira"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v13 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v14 = [
  {
    "kind": "Variable",
    "name": "applicationKey",
    "variableName": "applicationKey"
  },
  (v13/*: any*/)
],
v15 = {
  "condition": "shouldCheckForStorageUsageJira",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "shouldCheckForStorageLimit",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v14/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageAllowed"
            },
            {
              "args": (v14/*: any*/),
              "kind": "ScalarField",
              "name": "attachmentStorageIsUnlimited"
            }
          ]
        },
        {
          "args": (v14/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        }
      ]
    }
  ]
},
v16 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_SERVICE_DESK"
  },
  (v13/*: any*/)
],
v17 = [
  {
    "kind": "Literal",
    "name": "applicationKey",
    "value": "JIRA_CUSTOMER_SERVICE"
  },
  (v13/*: any*/)
],
v18 = {
  "condition": "isServiceCollectionFree",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "jsm_storage",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v16/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageAllowed"
        },
        {
          "args": (v16/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        },
        {
          "args": (v16/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageIsUnlimited"
        }
      ]
    },
    {
      "alias": "csm_storage",
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageAllowed"
        },
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageUsed"
        },
        {
          "args": (v17/*: any*/),
          "kind": "ScalarField",
          "name": "attachmentStorageIsUnlimited"
        }
      ]
    }
  ]
},
v19 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v20 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v21 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v22 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v23 = {
  "kind": "Literal",
  "name": "offeringName",
  "value": "Standard"
},
v24 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v25 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v26 = [
  (v24/*: any*/),
  (v25/*: any*/)
],
v27 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": [
        (v23/*: any*/)
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v26/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Standard\")"
    },
    {
      "condition": "shouldCheckForDirectBuyChangeOffering",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "changeOfferingV2WithSkipTrial",
          "args": [
            (v23/*: any*/),
            {
              "kind": "Literal",
              "name": "skipTrial",
              "value": true
            }
          ],
          "concreteType": "CcpChangeOfferingExperienceCapability",
          "kind": "LinkedField",
          "name": "changeOfferingV2",
          "plural": false,
          "selections": (v26/*: any*/),
          "storageKey": "changeOfferingV2(offeringName:\"Standard\",skipTrial:true)"
        }
      ]
    }
  ]
},
v28 = {
  "condition": "shouldCheckForChargeQuantities",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chargeElement",
          "variableName": "chargeElement"
        }
      ],
      "kind": "ScalarField",
      "name": "latestUsageForChargeElement"
    }
  ]
},
v29 = {
  "concreteType": "CcpEntitlementPreDunning",
  "kind": "LinkedField",
  "name": "preDunning",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "status"
    }
  ]
},
v30 = {
  "concreteType": "CcpTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeLeft"
    },
    {
      "kind": "ScalarField",
      "name": "startTimestamp"
    },
    {
      "kind": "ScalarField",
      "name": "endTimestamp"
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v32 = {
  "concreteType": "CcpInvoiceGroupExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpConfigurePaymentMethodExperienceCapability",
      "kind": "LinkedField",
      "name": "configurePaymentV2",
      "plural": false,
      "selections": [
        (v25/*: any*/),
        (v24/*: any*/)
      ]
    }
  ]
},
v33 = {
  "concreteType": "CcpOfferingTrial",
  "kind": "LinkedField",
  "name": "trial",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lengthDays"
    }
  ]
},
v34 = {
  "kind": "ScalarField",
  "name": "key"
},
v35 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v36 = {
  "condition": "shouldCheckForPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isBillToPresent"
        }
      ]
    }
  ]
},
v37 = {
  "condition": "shouldCheckForAddPaymentDetails",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "CcpTransactionAccount",
      "kind": "LinkedField",
      "name": "transactionAccount",
      "plural": false,
      "selections": [
        {
          "concreteType": "CcpTransactionAccountExperienceCapabilities",
          "kind": "LinkedField",
          "name": "experienceCapabilities",
          "plural": false,
          "selections": [
            {
              "concreteType": "CcpAddPaymentMethodExperienceCapability",
              "kind": "LinkedField",
              "name": "addPaymentMethodV2",
              "plural": false,
              "selections": (v26/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v38 = {
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "relationshipType"
    },
    (v21/*: any*/)
  ]
},
v39 = [
  {
    "kind": "Literal",
    "name": "relationshipTypes",
    "value": "COLLECTION"
  }
],
v40 = {
  "concreteType": "GrowthUnifiedProfileEntitlementProfileResult",
  "kind": "LinkedField",
  "name": "entitlementProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileEntitlementContextTrialResult",
      "kind": "LinkedField",
      "name": "lastKnownTrial",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "trialType"
        },
        {
          "kind": "ScalarField",
          "name": "trialTrigger"
        },
        {
          "kind": "ScalarField",
          "name": "trialEndTimeStamp"
        },
        {
          "kind": "ScalarField",
          "name": "createdAt"
        },
        {
          "kind": "ScalarField",
          "name": "offeringId"
        }
      ]
    }
  ]
},
v41 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      (v15/*: any*/),
      (v18/*: any*/),
      {
        "args": (v19/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v20/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v22/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      (v28/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v32/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v34/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v35/*: any*/)
                        ]
                      },
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v39/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v40/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v40/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "args": (v19/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v20/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v21/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v22/*: any*/),
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v27/*: any*/),
                      {
                        "concreteType": "CcpTransactionAccount",
                        "kind": "LinkedField",
                        "name": "transactionAccount",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v41/*: any*/)
                        ]
                      },
                      (v38/*: any*/),
                      {
                        "alias": "relatesFromEntitlementsWithCollectionType",
                        "args": (v39/*: any*/),
                        "concreteType": "CcpEntitlementRelationship",
                        "kind": "LinkedField",
                        "name": "relatesFromEntitlements",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "CcpEntitlement",
                            "kind": "LinkedField",
                            "name": "entitlement",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              (v40/*: any*/),
                              (v41/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
                      },
                      (v40/*: any*/),
                      (v41/*: any*/),
                      (v28/*: any*/),
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "concreteType": "CcpSubscription",
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v30/*: any*/),
                              {
                                "concreteType": "CcpAccountDetails",
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CcpInvoiceGroup",
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v41/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v41/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "CcpOffering",
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v33/*: any*/),
                              (v34/*: any*/),
                              (v41/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v36/*: any*/),
                      (v37/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      (v15/*: any*/),
      (v18/*: any*/)
    ]
  },
  "params": {
    "id": "e1ed8c49247d1a72a774293db1058ae7a1d107d6c5a61ec7bf1fe7e63e1231f7",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e8f593c1fcb568439b89613a08c9258f";

export default node;
